import { computed } from 'vue'
import { availableLocales } from '../constants/locale'
import { useLocaleStore } from '@/core/stores/locale'

export function useLanguage() {
  const localeStore = useLocaleStore()
  const { switchLanguage } = localeStore

  const currentLang = computed(() => localeStore.language)

  return {
    currentLang,
    availableLocales: [...availableLocales],
    switchLanguage,
  }
}
